// extracted by mini-css-extract-plugin
export var actionButton = "_mp-0";
export var fileInput = "_mp-2";
export var paperclip = "_mp-1";